import React from 'react';
import { Heading } from '@abyss/web/ui/Heading';
import { IconBrand } from '@abyss/web/ui/IconBrand';

import styles from './benefits.module.css';

export const Benefits = ({ title, items }) => {
  return (
    <div className={styles.benefits}>
      <div className={styles.heading}>
        <Heading.Level>
          <Heading>{title}</Heading>
        </Heading.Level>
      </div>
      <ul className={styles.benefitList}>
        {items.map((item, index) => {
          return (
            <li className={styles.listItem} key={index}>
              <div className={styles.icon}>
                <IconBrand size="48px" icon={item.icon} variant="twotone" />
              </div>
              <div className={styles.content}>
                {item.title && <div className={styles.title}>{item.title}</div>}

                <div
                  className={styles.copy}
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
